import React from 'react';

import { Stack, StackProps } from '_lib/components/Stack/Stack';
import { toSxArray } from '_lib/utils/helpers';

export type FlexStackProps = StackProps & {
  singleColumn: boolean;
};

/** Custom stack that switches between column and row layout based on the singleColumn prop */
export const FlexStack = (props: FlexStackProps) => {
  const { singleColumn, sx, ...restProps } = props;
  return (
    <Stack
      sx={[{ width: '100%' }, ...toSxArray(sx)]}
      useFlexGap
      {...restProps}
      direction={singleColumn ? 'column' : 'row'}
    />
  );
};
